import { moduleProviderFactory } from "core/providers";
import { TemplateReport } from "application/template-report/pages";

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: "master.app.main.template-report",
				pattern: "/template-report",
				children: [
					{
						name: "master.app.main.template-report.list",
						pattern: "",
						tabTitle: "MENU.TEMPLATE_REPORT",
						component: TemplateReport,
						authorization: "reportSection.read",
						data: {
							title: "MENU.TEMPLATE_REPORT",
						},
					}
				],
			},
		],
		menu : [
            {
                title: 'MENU.REPORTS',
                order: 9,
				icon: "table-view",
				authorization: "reportSection.read",
                subMenu: [
                    {
                        title: "MENU.TEMPLATE_REPORT",
						authorization: "coreUserSection.read",
						route: "master.app.main.template-report.list",
						order: 5
                    }                    
                ]
            }
        ]
	});
})();
